
// Logout.js
import { useEffect, useRef } from "react";
import { useAuth } from "../AuthContext";
import { useNavigate } from "react-router-dom";
import AddLog from "./AddLog"; // ✅ 로그 저장 함수 가져오기



const Logout = ({ setUserType = () => { } }) => {
//const Logout = () => {
    const { logout } = useAuth();
    const { user, setUser } = useAuth();

    const navigate = useNavigate();
    const userID = user?.userId || ""; // 로그인되지 않은 경우 빈 문자열
    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current) return; // 이미 실행되었으면 종료
        hasRun.current = true; // 첫 실행 후 플래그 설정
        logoutLog();
    }, []);

    useEffect(() => {        
        localStorage.removeItem("userType");
        setUserType("");
        setUser("");
        logout();  // 로그아웃 수행
        navigate("/login");  // 로그인 페이지로 이동 (필요에 따라 다른 페이지로 변경 가능)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [logout, navigate]);

    const logoutLog = async () => {
        await AddLog(userID, "", "", "2-1");
    }

    return null; // 화면에 아무것도 표시하지 않음
};

export default Logout;

